import Component from "@glimmer/component";
import { all, task } from "ember-concurrency";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import { LinkTo } from "@ember/routing";
import { on } from "@ember/modifier";
import { not, or } from "ember-truth-helpers";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import TaskForm from "glesys-controlpanel/components/task-form";
import Label from "glesys-controlpanel/components/label";
import GButton from "glesys-controlpanel/components/g-button";
import Select, { Option } from "glesys-controlpanel/components/select";

export default class ModalsServerAttachVolume extends Component {
  @service modal;

  @tracked selectedVolumeIds = [];

  get availableVolumes() {
    return this.args.params.volumes;
  }

  get server() {
    return this.args.params.server;
  }

  onFormChange = ({ volumes }) => {
    this.selectedVolumeIds = [].concat(volumes).filter(Boolean);
  };

  submitTask = task(async () => {
    let volumes = this.selectedVolumeIds.map((id) => this.availableVolumes.find((volume) => volume.id === id));

    await all(volumes.map((volume) => volume.attachTask.perform(this.server.id)));
    await this.args.params.onAttached?.();

    this.modal.close();
  });

  <template>
    <Header>
      {{t "server.volumes.attach.title"}}
    </Header>
    <Body>
      <TaskForm
        id="attach-volume"
        data-test-input-field-for-server-attach-volume
        @onChange={{this.onFormChange}}
        @task={{this.submitTask}}
      >
        <div class="min-h-32 max-h-128 overflow-auto">
          {{#if this.availableVolumes.length}}
            <Label for="volumes">
              {{t "server.volumes.attach.label"}}
            </Label>
            <Select id="volumes" data-test-server-attach-volume-select name="volumes" multiple size="6">
              {{#each this.availableVolumes as |volume|}}
                <Option
                  data-test-selectable-volume-item={{volume.id}}
                  value={{volume.id}}
                  disabled={{not volume.isReady}}
                >
                  {{volume.name}}
                  ({{volume.sizeInGib}}
                  GiB)
                  {{#unless volume.isReady}}
                    —
                    {{t volume.statusIndicator.labelKey}}
                  {{/unless}}
                </Option>
              {{/each}}
            </Select>
          {{else}}
            <div class="flex flex-col text-base text-gray-800" data-test-server-attach-volume-has-no-volumes>
              <span>{{t "server.volumes.attach.no-volumes"}}</span>
              <LinkTo data-test-server-attach-volume-create-link @route="block-storage" {{on "click" (modalClose)}}>
                {{t "server.volumes.attach.no-volumes-link"}}
              </LinkTo>
            </div>
          {{/if}}
        </div>
      </TaskForm>
    </Body>
    <Footer>
      <GButton class="mr-2" @type="button" @color="gray" {{on "click" (modalClose)}}>
        {{t "button.close"}}
      </GButton>
      <GButton
        data-test-server-attach-volume-submit
        form="attach-volume"
        @type="submit"
        @color="blue"
        @disabled={{or this.submitTask.isRunning (not this.selectedVolumeIds.length)}}
      >
        {{t "button.attach"}}
      </GButton>
    </Footer>
  </template>
}
